










import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ClipButton",
  props: {
    height: {
      type: String as PropType<Props["height"]>,
      default: "24"
    },
    width: {
      type: String as PropType<Props["width"]>,
      default: "24"
    },
    clipped: {
      type: Boolean as PropType<Props["clipped"]>,
      default: false
    }
  },
  computed: {
    clipClasses() {
      return [
        "clipButton",
        {
          "clipButton--clipped": this.clipped
        }
      ];
    }
  },
  methods: {
    toggleClipped() {
      this.$emit("toggleClipped", !this.clipped);
    }
  }
});
